var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-value_card",
    "data-name": "icon-value card",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_26",
    "data-name": "Exclusion 26",
    d: "M39.767,43.738H4V13.129L31.586,4.75a5.762,5.762,0,0,1,7.2,3.838l1.371,4.528a5.77,5.77,0,0,1,5.391,5.758v19.1a5.768,5.768,0,0,1-5.769,5.769ZM6.306,15.406V41.43H39.767a3.463,3.463,0,0,0,3.462-3.462v-19.1a3.461,3.461,0,0,0-3.462-3.462H6.306ZM33.26,6.8a3.443,3.443,0,0,0-1.006.155L12.031,13.1H37.739L36.571,9.266A3.4,3.4,0,0,0,34.9,7.216,3.545,3.545,0,0,0,33.26,6.8Zm3.367,23.8a1.722,1.722,0,1,1,.014,0h-.014Z",
    transform: "translate(5.228 5.882)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.4d6908687395fdda971ab2be28f647d6.svg";
export { ForwardRef as ReactComponent };